import useTranslation from '../../hooks/useTranslation'
import introBuild from '../../../assets/image/intro/box.png'
import ComponentRenderer from './ComponentRenderer'

function BuildContent() {
  const t = useTranslation()
  const intro = t.landing.intro.build
  return (
    <ComponentRenderer
      headline={intro.headline}
      bulletsTitle={intro.servicesLabel}
      subline={intro.body}
      bullets={intro.servicesList}
      image={introBuild}
      ctaLabel={intro.ctaLabel}
      ctaHref={intro.ctaHref}
    />
  )
}

export default BuildContent
